import type { JSONContent } from '@tiptap/core';

import type { SerializableNode } from '@/serializer';
import type { ProductData } from '@/types';

export const getButtonContent = (
  node: JSONContent & SerializableNode,
  product: ProductData,
): JSONContent[] | undefined => {
  if (node?.attrs?.mergeTag === 'product.cta_text') {
    return [
      {
        type: 'text',
        text: product?.cta_text || '',
      },
    ];
  }

  return node?.content;
};
